
    <div class="container">
      <div class="mat-title">
        {{ 'task-location-status' | translate | titlecase }}
      </div>

      <div fxLayout="column" fxLayoutGap="16px">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
          <div class="label mat-body-2">
            {{ 'task' | translate | titlecase }}:
          </div>
          <div class="mat-body-2">{{ data.task.name }}</div>
        </div>

        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
          <div class="label mat-body-2">
            {{ 'employee' | translate | titlecase }}:
          </div>
          <div class="mat-body-2">{{ employeeName || '-' }}</div>
        </div>

        <ml-select
          [label]="'status'"
          [filterable]="false"
          [options]="statuses"
          [translate]="true"
          [clear]="false"
          [control]="statusControl"
        ></ml-select>
      </div>

      <ml-dialog-actions
        [disable]="statusControl.invalid || loading"
        (clickLeft)="onClose()"
        (clickRight)="onSave()"
      ></ml-dialog-actions>
    </div>
  